export const PERMISSIONS = [
    {
        title: '我要询价列表',
        lists: [
            '添加单品', '编辑定制要求', '添加单品', '编辑定制要求', '添加单品', '编辑定制要求'
        ]
    },
    {
        title: '我要询价列表',
        lists: [
            '添加单品', '编辑定制要求', '添加单品', '编辑定制要求', '添加单品', '编辑定制要求'
        ]
    },
    {
        title: '我要询价列表',
        lists: [
            '添加单品', '编辑定制要求', '添加单品', '编辑定制要求', '添加单品', '编辑定制要求'
        ]
    },
    {
        title: '我要询价列表',
        lists: [
            '添加单品', '编辑定制要求', '添加单品', '编辑定制要求', '添加单品', '编辑定制要求'
        ]
    }
]